"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HBSidePanelExpandButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _ArrowsDiagonalOut = _interopRequireDefault(require("@honeybook/icons/dist/icons/ArrowsDiagonalOut16"));
var _HBIconButton = _interopRequireDefault(require("../HBIconButton/HBIconButton"));
var HBSidePanelExpandButton = exports.HBSidePanelExpandButton = function HBSidePanelExpandButton(_ref) {
  var onExpand = _ref.onExpand,
    testId = _ref.testId,
    _ref$testIdName = _ref.testIdName,
    testIdName = _ref$testIdName === void 0 ? 'expand' : _ref$testIdName;
  return /*#__PURE__*/_react["default"].createElement(_HBIconButton["default"], {
    buttonTheme: "subtle-invisible",
    icon: _ArrowsDiagonalOut["default"],
    label: "expand",
    onClick: onExpand,
    size: "xs",
    testId: testId,
    testIdName: testIdName
  });
};
//# sourceMappingURL=HBSidePanelExpandButton.js.map